// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoContas_StoreInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /planocontas
 *
 * Creates a new budget account (conta) in the plano de contas.
 */
import { registerContract } from './validate'

export interface PlanoContas_StoreInput {
fechamento_mensal_id: number
franquia_id: number
nome_conta: string
operacao?: string
tipo?: string
percentual_faturamento?: number
valor_previsto?: number
categoria_id?: number
}

registerContract('PlanoContas_StoreInput', {
  fechamento_mensal_id:   { type: 'number',  required: true },
  franquia_id:            { type: 'number',  required: true },
  nome_conta:             { type: 'string',  required: true },
  operacao:               { type: 'string',  required: false },
  tipo:                   { type: 'string',  required: false },
  percentual_faturamento: { type: 'number',  required: false },
  valor_previsto:         { type: 'number',  required: false },
  categoria_id:           { type: 'number',  required: false },
})
